import { BrandRepository } from '@/core/brand/domain/BrandRepository.ts'
import { BrandsClient } from 'online-customer-services-ts'
import { Brand } from '@/core/brand/domain/Brand.ts'

export class BrandRepositoryBackendClient implements BrandRepository {
  private readonly workshopClient: BrandsClient

  constructor(url: string) {
    this.workshopClient = new BrandsClient(url)
  }

  async getBrands(hostId: string): Promise<Brand[]> {
    const brands = await this.workshopClient.getMarketBrands(hostId)

    return brands.map((brand) => ({
      code: brand.code ?? '',
      name: brand.name ?? '',
      important: brand.important ?? false
    }))
  }
}
